<template>
  <Modal :modal="modal.filter" :action="() => _trigger()">
    <ModalBody>
      <FilterPerusahaan
        :model="filter"
        :response="response"
        :action="() => _getDepo()"
      />
      <FilterDepo
        :model="filter"
        :response="response"
        :action="
          () => {
            _getSalesman();
            _getDriver();
          }
        "
      />
      <FilterSalesman
        :model="filter"
        :response="response"
        v-if="currentRouteName == 'rekapitulasiDO'"
      />
      <FilterDriver
        :model="filter"
        :response="response"
        v-if="currentRouteName == 'rekapitulasiDODriver'"
      />
      <div class="row">
        <FilterDate
          :format="'col-6'"
          :parameter="'start_date'"
          :model="filter"
          :disabled="loading"
        />
        <FilterDate
          :format="'col-6'"
          :parameter="'end_date'"
          :model="filter"
          :disabled="loading"
        />
      </div>
      <FilterContainer :label="'Status'">
        <select class="form-control" v-model="filter.status">
          <option
            v-for="(d, i) in status"
            v-html="ucwords(d)"
            :value="d"
            :key="i"
          />
        </select>
      </FilterContainer>
    </ModalBody>
    <ModalFooter>
      <ButtonClose :disabled="loading" :action="() => _trigger()" />
      <ButtonSave :disabled="loading" :action="() => _submit()" />
    </ModalFooter>
  </Modal>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FilterPerusahaan from "@/components/filter/filter-perusahaan.vue";
import FilterDepo from "@/components/filter/filter-depo.vue";
import FilterSalesman from "@/components/filter/filter-salesman.vue";
import FilterDriver from "@/components/filter/filter-driver.vue";
import FilterContainer from "@/components/filter/filter-container.vue";
import FilterDate from "@//components/filter/filter-date.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    FilterPerusahaan,
    FilterDepo,
    FilterSalesman,
    FilterContainer,
    FilterDate,
    FilterDriver,
  },
  mixins: [helper],
  data() {
    return {
      status: ["all", "approved", "loaded", "delivered"],
    };
  },
  computed: {
    ...mapState(["loading"]),
    ...mapState("rekapitulasi_do", {
      modal: (state) => state.modal,
      filter: (state) => state.filter,
      response: (state) => state.response,
    }),
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    ...mapActions("rekapitulasi_do", ["triggerModal", "getRekapitulasiDo"]),
    ...mapActions("perusahaan", ["getListPerusahaanByAccess"]),
    ...mapActions("depo", ["getListDepoByUser"]),
    ...mapActions("salesman", ["getListSalesmanPenjualan"]),
    ...mapActions("driver", ["getListDriver"]),
    _trigger() {
      return this.triggerModal("filter");
    },
    _submit() {
      this.getRekapitulasiDo();
      this._trigger();
    },
    _getPerusahaan() {
      this.getListPerusahaanByAccess().then((res) => {
        this.response.filter.perusahaans = res;
      });
    },
    _getDepo() {
      let id = this.filter.id_perusahaan;
      this.getListDepoByUser({ id_perusahaan: id }).then((res) => {
        this.response.filter.depos = res;
      });
    },
    _getSalesman() {
      let payload = {
        depo: this.filter.id_depo,
        id_perusahaan: this.filter.id_perusahaan,
      };
      this.getListSalesmanPenjualan(payload).then((res) => {
        this.response.filter.salesmans = res;
      });
    },
    _getDriver() {
      this.getListDriver(this.filter.id_depo).then((res) => {
        this.response.filter.drivers = res;
      });
    },
  },
  mounted() {
    this._getPerusahaan();
  },
  created() {},
};
</script>
